import { createSelector } from '@ngrx/store';

import { State } from './reducer';
import { selectLoginState } from '../selectors';
import { LoginResponse } from '@models/swagger';

export const getData = createSelector(selectLoginState, (state: State) => state.data);

export const getError = createSelector(selectLoginState, (state: State) => state.error);

export const getLoading = createSelector(selectLoginState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: LoginResponse | null) => T) =>
  createSelector(selectLoginState, (state: State) => fn(state.data));
